import { UcrRoundOut, UcrSetting, UcrUserDefault } from '@ucr/icons';

export const accountMenu = [
  {
    title: 'Профиль',
    icon: UcrUserDefault,
    link: '/profile',
    disabled: true,
  },
  {
    title: 'Настройки',
    icon: UcrSetting,
    link: '/settings',
    disabled: true,
  },
  {
    title: 'Выход',
    icon: UcrRoundOut,
    link: '/logout',
    disabled: false,
  },
];
